
import { Component, Vue, Prop } from 'vue-property-decorator';

import GetHelpScanning from "../helpPages/GetHelpScanning.vue"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
import { requiredDocumentsInfoType } from '@/types/Common';
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
import { stepInfoType } from '@/types/Application';
const applicationState = namespace("Application");

@Component({
    components:{        
        GetHelpScanning,
    }
}) 
export default class RequiredDocument extends Vue {
    
    @Prop({required: true})
    type!: string;

    @Prop({required: false, default:'Additional Documents to Include:'})
    title!: string;

    @applicationState.State
    public requiredDocuments!: requiredDocumentsInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType; 

    @applicationState.State
    public steps!: stepInfoType[];

    @applicationState.State
    public rejectedPathway!: boolean;
        
    @applicationState.State
    public rejectedFormsList!: any[];

    showGetHelpScanning = false;
    isRequiredDocument = false;
    requiredDocumentLists = [];

    mounted(){
        Vue.filter('replaceRequiredDocuments')()
        this.getRequiredDocuments()
    }

    public getRequiredDocuments(){
        this.requiredDocumentLists = [];
        this.isRequiredDocument = false;
        
        const includesOrderActivities = this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedActivity.includes('applyForOrder');
        const includesReplyActivities = this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedActivity.includes('replyToApplication');
        
        const selectedForms = (includesOrderActivities && this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedForms?.length > 0)?this.steps[this.stPgNo.GETSTART._StepNo].result.selectedForms:[];
        const selectedReplyForms = (includesReplyActivities && this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedReplyForms?.length > 0)?this.steps[this.stPgNo.GETSTART._StepNo].result.selectedReplyForms:[];
        
        if(this.rejectedPathway){
            const forms =this.rejectedFormsList.map(form => form['description']+' document (<b>' +form['type']+'</b>)')
            this.requiredDocumentLists.push({
                name: '', 
                required: forms, 
                reminder: [],
                text: 'To Resubmit the Application',
                article: ''
            })
            this.isRequiredDocument = true;
        }
        else{

            for (const [key, value] of Object.entries(this.requiredDocuments)){           
                if(key && value && 
                    ( selectedForms.includes(key) || selectedForms.includes(key.slice(0,-2)) 
                    || selectedReplyForms.includes(key) || selectedReplyForms.includes(key.slice(0,-2)) ) ){
                    
                    const name = Vue.filter('getFullOrderName')(key, '');
                    const vowelCondition = ['A','E','I','O','U'].includes(name.substring(0,1))?'an':'a';
                    this.requiredDocumentLists.push({
                        name:name, 
                        required:JSON.parse(JSON.stringify(value['required'])), 
                        reminder:value['reminder'],
                        text:key.includes('agreementEnfrc2')?'For the Request to':'For the Application About',
                        article:key.includes('agreementEnfrc2')? '':vowelCondition
                    })
                    if(value['required']?.length>0) this.isRequiredDocument = true;
                }
            }
            

            //Remove redundant docs        
            for(const requiredDocList of this.requiredDocumentLists){
                const requiredDoc = requiredDocList.required
                //console.log(requiredDoc)
                const inxToRemove = []
                for(let i=0; i<requiredDoc.length; i++){
                    if(requiredDoc[i].includes('Financial Statement Form 4')){                    
                        inxToRemove.push(i)
                    }                
                }
                //console.log(inxToRemove)
                for (let i = inxToRemove.length -1; i > 0; i--)
                    requiredDoc.splice(inxToRemove[i],1);
            }
        }

    }
}
